import { CustomDialog } from "../../../../components";
import React from "react";
import PropTypes from "prop-types";

const WlzPopup = ({ show, hide, title, content, label }) => {
  return (
    <CustomDialog
      open={show}
      onClose={hide}
      title={title}
      content={
        <span className="wlz-popup">
          {content}
        </span>
      }
      actions={[
        { label: label, onClick: hide },
      ]}
    />
  );
};

WlzPopup.propTypes = {
  show: PropTypes.bool,
  hide: PropTypes.func,
  title: PropTypes.string,
  content: PropTypes.string,
  label: PropTypes.string,
};

export default WlzPopup;